import { render, staticRenderFns } from "./pif-mini.html?vue&type=template&id=a158d192&"
import script from "./PifMini.vue?vue&type=script&lang=js&"
export * from "./PifMini.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports